import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Load Eruda mobile debugger only if REACT_APP_DEBUG is set
if (process.env.REACT_APP_DEBUG === 'true') {
  import('eruda').then(eruda => eruda.default.init());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);